import { IntegrationModuleListItem } from 'components/Integrations/components/IntegrationModuleListItem';
import React from 'react';

// TODO: Add actual GruntWorx logo to images folder
const gruntworxSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iIzAwNzNlNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE0IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkdydW50V29yeDwvdGV4dD48L3N2Zz4=';
 
export const GruntworxIntegrationListItem = () => (
  <IntegrationModuleListItem iconSrc={gruntworxSrc} content="GruntWorx" />
); 